<template>
  <LlTooltip location="left">
    <template #default>
      <div class="max-w-[260px]">{{ reason }}</div>
    </template>
    <template #activator>
      <LlListItem
        color="muted"
        :data-cy="dataCy"
        aria-disabled="true"
        :aria-label="`Submit to QuickBooks unavailable. ${reason}`"
      >
        <span class="flex items-center gap-1.5">
          <QboIcon :size="16" />
          Submit to QuickBooks
        </span>
      </LlListItem>
    </template>
  </LlTooltip>
</template>

<script setup lang="ts">
import LlTooltip from '@/components/LlTooltip.vue';
import LlListItem from '@/components/LlListItem.vue';
import QboIcon from '@/components/QboIcon.vue';

// Not `disabled`: Vuetify's disabled list item drops pointer events, which would kill the tooltip.
defineProps<{
  reason: string;
  dataCy: string;
}>();
</script>
